import { Request } from '../../../../../../httpClient/serverApi/requests/Request';
import { IIpAllowListApiResult } from '../types/IpAllowList';

/**
 * Parameters for getting the IP allowlist
 */
export interface IGetIpAllowListParams {
}

/**
 * Result containing the IP allowlist information
 */
export interface IGetIpAllowListResult extends IIpAllowListApiResult {
}

/**
 * Request class for fetching the IP allowlist configuration
 * @example
 * const request = new GetIpAllowListRequest();
 * const result = await WebHttpClient.sendRequest(request);
 */
export class GetIpAllowListRequest extends Request<IGetIpAllowListParams, IGetIpAllowListResult> {
  constructor(params: IGetIpAllowListParams = {}) {
    super('getIpAllowList', params);
  }
}